"use client";

import React from 'react';
import Link from 'next/link';

const FinalCTABookingSection = () => {
  return (
    <section className="relative bg-navy py-12 sm:py-16 md:py-24 min-h-0 flex items-center overflow-hidden">
      {/* Animated particle effect background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-2 h-2 bg-gold rounded-full animate-pulse"></div>
        <div className="absolute top-20 right-20 w-1 h-1 bg-gold rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute bottom-20 left-1/4 w-1.5 h-1.5 bg-gold rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-gold rounded-full animate-pulse" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute bottom-1/4 right-1/4 w-2 h-2 bg-gold rounded-full animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 xl:gap-16 items-center">
          {/* Left: Content */}
          <div>
            <h2 className="font-serif text-white text-[26px] sm:text-[34px] md:text-[42px] lg:text-[48px] leading-[1.2] font-bold text-left mb-4 sm:mb-6">
              Stop Managing Data Chaos. Start Driving with Clarity.
            </h2>
            <p className="text-white/80 text-[15px] sm:text-[18px] md:text-[20px] lg:text-[22px] leading-[1.7] text-left max-w-xl">
              Schedule a 30-minute diagnostic call with our EDW specialists. No sales pitch–just a candid conversation about your data challenges.
            </p>
          </div>

          {/* Right: Booking Card */}
          <div className="flex justify-start lg:justify-end">
            <div
              className="w-full max-w-[500px] bg-white/8 border border-white/20 rounded-xl sm:rounded-2xl p-6 sm:p-10 md:p-12 text-left"
              style={{
                boxShadow: '0 0 40px rgba(197, 165, 114, 0.2)'
              }}
            >
              {/* Calendar Icon */}
              <div className="flex justify-start mb-4 sm:mb-6">
                <div className="w-12 h-12 sm:w-16 sm:h-16 border-2 border-gold rounded-lg flex items-center justify-center">
                  <span className="text-gold text-2xl sm:text-3xl">📅</span>
                </div>
              </div>

              {/* Card Title */}
              <h3 className="text-white text-xl sm:text-2xl font-bold mb-2 sm:mb-3">Schedule Diagnostic Call</h3>

              {/* Card Subtitle */}
              <p className="text-white/70 text-[14px] sm:text-base mb-6 sm:mb-8">30 minutes | Zero commitment</p>

              {/* CTA Button */}
              <Link href="/contact" className="inline-block text-center w-full sm:w-auto min-h-[48px] bg-gold text-navy px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-semibold text-base sm:text-lg hover:bg-gold/90 transition-all shadow-lg hover:shadow-xl active:scale-[0.98]">
                Book Now →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTABookingSection;